/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LessThanFilesize: core.serialization.ObjectSchema<
    serializers.LessThanFilesize.Raw,
    Truvity.LessThanFilesize
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace LessThanFilesize {
    export interface Raw {
        value: number;
    }
}
